module.exports = __webpack_public_path__ + "061163a3192e7e88faa38f593cef95b4.svg";